import React, { useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, Typography, Link,
} from '@material-ui/core'
import { NumericFormat } from 'react-number-format'
import { useTranslation } from 'react-i18next'

const r2 = (n) => Math.round(Number(n || 0) * 100) / 100

const DevolverSaldoModal = ({ resgate, onFechar, onConfirmar }) => {
  const { t, i18n } = useTranslation()
  const ehPt = i18n.language === 'pt-BR'
  const fmt = (n) => Number(n || 0).toLocaleString(ehPt ? 'pt-BR' : 'en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

  const resgatado = r2(resgate.quantidadeTotal)
  const utilizado = r2((resgate.alocacoes || []).reduce((s, a) => s + Number(a.quantidade || 0), 0))
  const devolvivel = r2(resgatado - utilizado)

  const [quantidade, setQuantidade] = useState(devolvivel)

  const qtd = r2(quantidade)
  const invalido = !(qtd > 0) || qtd > devolvivel
  const removeResgate = qtd > 0 && r2(resgatado - qtd) === 0

  return (
    <Dialog open fullWidth maxWidth="sm" onClose={onFechar}>
      <DialogTitle>{t('resgatesLbc.devolverTitulo')}</DialogTitle>
      <DialogContent>
        <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
          {resgate.titulo?.codigo || `#${resgate.tituloLbcId}`}
        </Typography>
        <Grid container spacing={2} style={{ marginTop: 4, marginBottom: 4 }}>
          <Grid item xs={4}>
            <Typography variant="caption" color="textSecondary">{t('resgatesLbc.resgatado')}</Typography>
            <Typography variant="subtitle2">{fmt(resgatado)}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="caption" color="textSecondary">{t('resgatesLbc.utilizado')}</Typography>
            <Typography variant="subtitle2">{fmt(utilizado)}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="caption" color="textSecondary">{t('resgatesLbc.saldoDevolver')}</Typography>
            <Typography variant="subtitle2" style={{ color: '#219754', fontWeight: 600 }}>{fmt(devolvivel)}</Typography>
          </Grid>
        </Grid>
        <NumericFormat
          customInput={TextField} fullWidth size="small" label={t('resgatesLbc.quantidadeDevolver')}
          data-testid="devolver-quantidade"
          value={quantidade}
          thousandSeparator={ehPt ? '.' : ','} decimalSeparator={ehPt ? ',' : '.'}
          decimalScale={2} allowNegative={false}
          onValueChange={(vals) => setQuantidade(vals.floatValue ?? '')}
        />
        <Link
          component="button" type="button" variant="caption" underline="always"
          onClick={() => setQuantidade(devolvivel)}
          style={{ marginTop: 4, display: 'inline-block' }}
        >
          {t('resgatesLbc.devolverTudo')}
        </Link>
        {removeResgate && (
          <Typography variant="caption" style={{ display: 'block', marginTop: 10, color: '#EE7D40' }}>
            {t('resgatesLbc.devolverRemoveAviso')}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onFechar}>{t('inputs.cancelar')}</Button>
        <Button
          color="primary" variant="contained" disabled={invalido}
          onClick={() => onConfirmar(qtd)}
        >
          {t('resgatesLbc.confirmarDevolucao')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DevolverSaldoModal
